import React from 'react'
import styled from 'styled-components'

import ValueCard from './ValueCard'
import values from './values'

const Inner = styled.div`
  width: fit-content;
  display: flex;
  padding: 0 16px;
  margin-bottom: 16px;

  & > *:not(:last-child) {
    margin-right: 32px;
  }
`

const HorizontalList = () => {
  return (
    <Inner>
      {values.map(({ text, Icon, backgroundColor }) => {
        return (
          <ValueCard
            key={text}
            icon={<Icon />}
            text={text}
            backgroundColor={backgroundColor}
          />
        )
      })}
    </Inner>
  )
}

export default HorizontalList
